import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { trackEvent } from './simple-tracker';
import { capturePageview, identifyUser } from './posthogClient';

const PageTracker = () => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Track page views to custom DB
    trackEvent('page_view', {
      pageUrl: window.location.href,
      path: location.pathname
    });

    identifyUser(user);
    capturePageview(location.pathname);
  }, [location, user]);

  return null;
};

export default PageTracker;
